function initColorOptions() {
  const $colorOptionContainers = $('.color-options-container');
  
  $colorOptionContainers.each(function() {
    const $container = $(this);
    let exploreMore = false;
    const $moreButtonContainer = $container.find('.color-options-more-container');
    const $moreButton = $moreButtonContainer.find('.color-options-more');
    const $customOptions = $container.find('.option-item:not(.color-options-more-container):not(:has(input[name="Color"][value*="(In Stock)"])');
    if ($customOptions.length > 6) {
      // Hide options beyond the first 6
      $customOptions.slice(6).hide();
      if ($moreButtonContainer) {
        $moreButtonContainer.show();
        $moreButton.on('click', () => {
          exploreMore = !exploreMore;
          if (exploreMore) {
            $moreButton.text('Show Less');
            $customOptions.show();
            $moreButton.addClass('expanded');
          } else {
            $moreButton.text('Show More');
            $customOptions.slice(6).hide();
            $moreButtonContainer.show();
            $moreButton.removeClass('expanded');
          }
          
        });
      }
    } else {
      // Hide the more button if there are 6 or fewer options
      if ($moreButtonContainer) {
        $moreButtonContainer.hide();
      }
    }
    $container.css('display', 'grid');
  });
}

// Initialize when the DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initColorOptions);
} else {
  initColorOptions();
} 